import { useState, useContext } from "react";
import {
  Box,
  Grid,
  Button,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TableContainer,
} from "@mui/material";
//Srcs
import "../../../Style/pagestyle.scss";
import moment from "moment";
import EmptyData from "../../../Components/Include/EmptyData";
import MandateForm from "../Form/MandateForm";
import LoadingPage from "../../../Utils/LoadingPage";
import SwitchStatus from "./SwitchStatus";
import MandateAction from "../MandateAction";
import FooterPagination from "../../../Utils/FooterPagination";
import useWithDimension from "../../../Hooks/useWithDimension";

import { AuthContext } from "../../../Context/AuthContext";
import { useGetMandatePagination } from "../../../Hooks/useGetMandatePagination";
import { ButtonCreate, SearchTextField } from "../../../Utils/Component";
import { getKhmerNumber } from "../../../Function/DynamicFn";

const handleGoToMandate = (id) => {
  window.localStorage.setItem("mandate_id", id);
  window.location.reload();
};

export default function User() {
  const { t, language } = useContext(AuthContext);

  const userLogin = JSON.parse(window.localStorage.getItem("userLogin"));

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const {
    page,
    limit,
    setPage,
    refetch,
    loading,
    tableData,
    setLoading,
    handleLimit,
    handleSearch, 
    paginationData,
  } = useGetMandatePagination();

  const level = language === "kh" ? "ទី" : " ";
  // ======================= Resize width Screen ======================
  const { width } = useWithDimension();
  return (
    <div className="page-container">
      <Box sx={{ marginTop: 3 }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={5} md={3.5} lg={3.5}>
            <SearchTextField
              className={"text-field"}
              handleSearch={handleSearch}
            />
          </Grid>

          <Grid item xs={6} sm={7} md={8.5} lg={8.5}>
            {/* {hasPermission(userLogin?.user?.role, "create:user") && ( */}
            <ButtonCreate
              handleOpen={handleOpen}
              classBtn={"btn-create"}
              classIcon={"icon-add"}
            />
            {/* )} */}

            {open && (
              <MandateForm
                open={open}
                setRefetch={refetch}
                dialogTitle={"Create"}
                handleClose={handleClose}
              />
            )}
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableRow>
                <TableCell className={t("class-name-header-title-start")}>
                  {t("thead_mandate")}
                </TableCell>

                <TableCell className={t("class-name-header-title")}>
                  {t("thead_total_party")}
                </TableCell>

                <TableCell className={t("class-name-header-title")}>
                  {t("thead_total_member")}
                </TableCell>

                <TableCell className={t("class-name-header-title")}>
                  {t("thead_start_date")}
                </TableCell>

                <TableCell className={t("class-name-header-title")}>
                  {t("thead_end_date")}
                </TableCell>

                <TableCell className={t("class-name-header-title")}></TableCell>

                <TableCell className={t("class-name-header-title")}>
                  {t("thead_status")}
                </TableCell>

                <TableCell
                  className={t("class-name-header-title-end")}
                ></TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell
                    colSpan={8}
                    className="body-cell"
                    sx={{ bgcolor: "#fff" }}
                  >
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 || tableData?.length === undefined ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={8} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <>
                    <TableBody className="body">
                      {tableData?.map((row, index) => {
                        const mandate =
                          language === "kh"
                            ? getKhmerNumber(
                              parseFloat(row?.mandateName)
                            )
                            : row?.mandateName;
                        return (
                          <TableRow className="body-row" key={index}>
                            <TableCell className="body-cell-start">
                              {t("thead_mandate") + level + mandate || ""}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.totalParty}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.totalMember} {t("thead_people")}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.startDate &&
                                moment(row?.startDate).format("DD-MM-YYYY")}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.endDate &&
                                moment(row?.endDate).format("DD-MM-YYYY")}
                            </TableCell>
                            <TableCell className="body-cell" align="center">
                              <Button
                                variant="contained"
                                sx={{ textTransform: "none" }}
                                onClick={() => handleGoToMandate(row?._id)}
                              >
                                {t("thead_go_to_mandate")}
                              </Button>
                            </TableCell>
                            <TableCell className="body-cell">
                              <SwitchStatus row={row} setRefetch={refetch} />
                            </TableCell>
                            <TableCell className="body-cell-end" align="right">
                              <MandateAction
                                editData={row}
                                setRefetch={refetch}
                                userLogin={userLogin}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </>
                )}
              </>
            )}
          </Table>
        </TableContainer>

        {/* ============================ Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          setLoading={setLoading}
        />
      </Box>
    </div>
  );
}
